import React, { useContext } from 'react'
import check from '../../assets/feedback/check.svg'
import exclamation from '../../assets/feedback/exclamation.svg'
import cross from '../../assets/feedback/cross.svg'
import { MessageBox, MessageDiv, MessageHeader, MessageIcon, MessageStatus, MessageText, TipDiv } from './style'
import { FeedbackContext } from '../../contexts/FeedbackContext'

const FeedbackComponent:React.FC = () => {
  const { feedback, setFeedback } = useContext(FeedbackContext)
  const { message, statusOk } = feedback
    
  return (
    <MessageBox className={statusOk ? '' : 'error'}>
      <MessageHeader onClick={() => setFeedback({isOpen:false,message:'',statusOk:true})}>
        <img src={cross} alt="cross icon" />
      </MessageHeader>
      <MessageDiv>
        <MessageIcon src={statusOk ? check : exclamation} alt="check icon" draggable='false' />
        <TipDiv>
          <MessageStatus>{statusOk ? 'Sucesso' : 'Algo inesperado aconteceu'}</MessageStatus>
          <MessageText>{message}</MessageText>
        </TipDiv>
      </MessageDiv>
    </MessageBox>
  )
}

export default FeedbackComponent